import * as React from "react";
import { NavLink } from "react-router-dom";
import { GeneralAction } from "actions/general-action";
import { getFirstAvailableSubMenuRoute } from "../../../../utils/navigationUtils";

const EventDetailsSection = ({
  event,
  eventStep,
  dispatch,
  t,
  event_id,
  editData,
  isMenuItemAvailable,
  isChildMenuItemAvailable,
  completed_modules,
  in_array,
  getParentMenuSortOrder,
  getParentMenuDisplayNumber,
  isParentMenuAvailable,
  menuHierarchy,
}) => {
  if (!isParentMenuAvailable("event_details")) return null;

  const isActive = () => window.location.pathname.includes("/event/create") || window.location.pathname.includes("event/edit");

  // Get the first available sub-menu route for event_details
  const firstAvailableRoute = getFirstAvailableSubMenuRoute("event_details", menuHierarchy);

  // Get children for this parent from menuHierarchy, sorted by sort_order
  const eventDetailsNode = Array.isArray(menuHierarchy)
    ? menuHierarchy.find((item) => item.alias === "event_details")
    : null;

  const sortedChildren =
    eventDetailsNode && Array.isArray(eventDetailsNode.children)
      ? [...eventDetailsNode.children]
          .filter((child) => isChildMenuItemAvailable("event_details", child.alias))
          .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
      : [];

  const renderChildItem = (child) => {
    switch (child.alias) {
      case "event_setup":
        return (
          <li key={child.id}>
            {eventStep === 1 ? (
              <span className="active">{t("M_EVENT_SETUP")}</span>
            ) : (
              <span
                onClick={() => dispatch(GeneralAction.step(1))}
                className="activeCompleted"
              >
                {t("M_EVENT_SETUP")}
              </span>
            )}
          </li>
        );
      case "event_details":
        return (
          <li key={child.id}>
            {eventStep === 2 ? (
              <span className="active">{t("M_EVENT_DETAILS")}</span>
            ) : eventStep > 2 ? (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => dispatch(GeneralAction.step(2))}
                className="activeCompleted"
              >
                {t("M_EVENT_DETAILS")}
              </span>
            ) : editData ? (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => dispatch(GeneralAction.step(2))}
              >
                {t("M_EVENT_DETAILS")}
              </span>
            ) : (
              <span>{t("M_EVENT_DETAILS")}</span>
            )}
          </li>
        );
      case "date_location":
        return (
          <li key={child.id}>
            {eventStep === 3 ? (
              <span className="active">{t("M_EVENT_DATE_AND_LOCATION")}</span>
            ) : eventStep > 3 ? (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => dispatch(GeneralAction.step(3))}
                className="activeCompleted"
              >
                {t("M_EVENT_DATE_AND_LOCATION")}
              </span>
            ) : editData ? (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => dispatch(GeneralAction.step(3))}
              >
                {t("M_EVENT_DATE_AND_LOCATION")}
              </span>
            ) : (
              <span>{t("M_EVENT_DATE_AND_LOCATION")}</span>
            )}
          </li>
        );
      case "event_calendar_description":
        return (
          <li key={child.id}>
            {eventStep === 4 ? (
              <span className="active">{t("M_EVENT_CALENDAR_DESCRIPTION")}</span>
            ) : eventStep > 4 ? (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => dispatch(GeneralAction.step(4))}
                className="activeCompleted"
              >
                {t("M_EVENT_CALENDAR_DESCRIPTION")}
              </span>
            ) : editData ? (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => dispatch(GeneralAction.step(4))}
              >
                {t("M_EVENT_CALENDAR_DESCRIPTION")}
              </span>
            ) : (
              <span>{t("M_EVENT_CALENDAR_DESCRIPTION")}</span>
            )}
          </li>
        );
      default:
        return null;
    }
  };

  return (
    <li
      style={{ order: getParentMenuSortOrder("event_details"), counterSet: `section ${getParentMenuDisplayNumber("event_details")}` }}
      className={`${isActive() ? "bold activeList" : ""} ${in_array("event", completed_modules) ? "completed" : ""}`}
    >
      {window.location.pathname.includes("event/create") ? (
        <span>
          <NavLink
            to="/event/create"
            onClick={() => {
              dispatch(GeneralAction.step(1));
            }}
          >
            {t("G_CREATE_EVENT")}
          </NavLink>
        </span>
      ) : (
        <span>
          <NavLink
            to={firstAvailableRoute || `/event/edit/${event_id}`}
            onClick={() => {
              dispatch(GeneralAction.step(1));
            }}
          >
            {t("M_ENTER_EVENT_DETAILS")}
          </NavLink>
        </span>
      )}
      <ul>
        {sortedChildren.map((child) => renderChildItem(child)).filter(Boolean)}
      </ul>
    </li>
  );
};

export default EventDetailsSection;
